
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 2036","transform":"translate(-304 -636)"}},[_c('circle',{attrs:{"data-name":"타원 251","cx":"14","cy":"14","r":"14","transform":"translate(304 636)","fill":"#f36628"}}),_c('path',{attrs:{"data-name":"Icon ionic-md-arrow-round-up","d":"M323.34 649.016l-4.57-4.709a1.039 1.039 0 00-.76-.307h-.014a1.039 1.039 0 00-.764.307l-4.572 4.709a1.008 1.008 0 000 1.473 1.128 1.128 0 001.541 0l2.709-2.83v7.3a1.092 1.092 0 002.182 0v-7.3l2.708 2.83a1.128 1.128 0 001.541 0 1.008 1.008 0 00-.001-1.473z","fill":"#fff"}})])])
          )
        }
      }
    